export interface Rect {
    x: number;
    y: number;
    w: number;
    h: number;
    color: string;
    label?: string;
    type?: string;
}

export interface RemotePlayer {
    sid: string;
    nickname: string;
    x: number;
    y: number;
    color: string;
    targetX: number;
    targetY: number;
    status: string;
    department: string;
    realName: string;
    title: string;
    isJumping?: boolean;
    jumpStartTime?: number;
    shape?: string;
}

export interface ChatMessage {
    sid: string;
    userId?: string;
    nickname: string;
    message: string;
    color: string;
    timestamp: number;
    type?: string;
    scope?: string;
    noUnread?: boolean;
}

export interface SpeechBubble {
    message: string;
    expireAt: number;
    scope?: string;
}

export const STATUS_OPTIONS = [
    { value: 'in', label: '출근', color: '#10B981' },
    { value: 'away', label: '자리비움', color: '#F59E0B' },
    { value: 'trip', label: '출장', color: '#3B82F6' },
    { value: 'vacation', label: '휴가', color: '#A78BFA' },
    { value: 'out', label: '퇴근', color: '#9CA3AF' },
];

export function getStatusColor(status: string): string {
    const opt = STATUS_OPTIONS.find(o => o.value === status);
    return opt ? opt.color : '#9CA3AF';
}

export function getStatusLabel(status: string): string {
    const opt = STATUS_OPTIONS.find(o => o.value === status);
    return opt ? opt.label : '알 수 없음';
}
